import { useState } from 'react';
import InitFilters from './components/InitFiltering';

const useCustomHook = () => {
  const [more, setMore] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [hasProfile, setHasProfile] = useState(false);

  const [targetUserInfo, setTargetUserInfo] = useState(null);
  const [filters, setFilters] = useState(InitFilters());
  const [filterParams, setFilterParams] = useState(null);
  const [emptyLabel, setEmptyLabel] = useState('داده‌ای یافت نشد!');
  const [size, setSize] = useState(50);
  const [selectedCheckData, setSelectedCheckData] = useState(null);
  const [page, setPage] = useState(0);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [actionType, setActionType] = useState('');
  const [businessCallBackUri, setBusinessCallBackUri] = useState(null);
  const [isOpenDialogCallbackUri, setIsOpenDialogCallbackUri] = useState(false);

  const [loading, setLoading] = useState(true);
  const [link, setLink] = useState('');
  const [paymentLinkShare, setPaymentLinkShare] = useState(null);
  const [redirectUri, setRedirectUri] = useState(null);

  return {
    hasProfile, setHasProfile,
    loading, setLoading,
    link, setLink,
    paymentLinkShare, setPaymentLinkShare,
    redirectUri, setRedirectUri,
    page, setPage,
    more, setMore,
    data, setData,
    isLoading, setIsLoading,
    page, setPage,
    targetUserInfo, setTargetUserInfo,
    filters, setFilters,
    filterParams, setFilterParams,
    emptyLabel, setEmptyLabel,
    size, setSize,
    isOpenDialog, setIsOpenDialog,
    selectedRowData, setSelectedRowData,
    actionType, setActionType,
    businessCallBackUri, setBusinessCallBackUri,
    isOpenDialogCallbackUri, setIsOpenDialogCallbackUri,
    selectedCheckData, setSelectedCheckData
  };
};

export default useCustomHook;
